var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg009Historisch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_03_History_Recent",
    "data-name": "03  History, Recent"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30 16a13 13 0 0 1 -23.46 7.72l1.61-1.19a11 11 0 1 0 -1.67-9.71l1-.65 1.12 1.66-3 2a1 1 0 0 1 -.6.17 1 1 0 0 1 -.83-.44l-2-3 1.66-1.12.68 1a13 13 0 0 1 25.49 3.56zm-14-7v7a1 1 0 0 0 .29.71l3 3 1.42-1.42-2.71-2.7v-6.59z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg009Historisch);
export default __webpack_public_path__ + "static/media/009-historisch.6a6f74c47613f466c89b9a16cfacf46f.svg";
export { ForwardRef as ReactComponent };